/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Speaker_Assignment_NeverInputs */



/**
* | output |
* | --- |
* | "Never" |
*
* @param {Options_Editor_Speaker_Assignment_NeverInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_speaker_assignment_never = /** @type {((inputs?: Options_Editor_Speaker_Assignment_NeverInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Speaker_Assignment_NeverInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Jamais")
	if (locale === "de") return /** @type {LocalizedString} */ ("Niemals")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mai")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Никогда")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nunca")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("绝不")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一度もない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कभी नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nunca")
	return /** @type {LocalizedString} */ ("Never")
});